import request from '@/utils/request'

/**
* 锚位管理API
*
* @author ljw
* @since 2025/03/28
*/

/**
* 基础接口
*
* @type {string}
*/
export const BASE_URL = 'manage/anchor-point'

/**
* 分页查询接口
*
* @type {string}
*/
export const PAGE_URL = `${BASE_URL}/page`

/**
* 查询指定ID的数据
*
* @param id ID
* @returns {Promise}
*/
export function get(id: any) {
  return request({
    url: `${BASE_URL}/${id}`,
    method: 'get'
  })
}

/**
* 保存数据
*
* @param data 数据
* @returns {Promise}
*/
export function save(data: any) {
  return request({
    url: BASE_URL,
    method: 'post',
    data: data
  })
}

/**
* 更新数据
*
* @param data 数据
* @returns {Promise}
*/
export function update(data: any) {
  return request({
    url: BASE_URL,
    method: 'put',
    data: data
  })
}

/**
* 删除数据
*
* @param idList ID数组
* @returns {Promise}
*/
export function remove(idList: any) {
  return request({
    url: BASE_URL,
    method: 'delete',
    data: idList
  },{showErrorMessage:false})
}

/**
 * 修改状态
 * @param data
 */
export function updateUseFlag(data: any) {
  return request({
    url: `${BASE_URL}/updateUseFlag`,
    method: 'put',
    data: data
  })
}

/**
 * 修改定位状态
 * @param data
 */
export function updateLocationEnable(data: any) {
  return request({
    url: `${BASE_URL}/updateLocationEnable`,
    method: 'put',
    data: data
  })
}

/**
* 查询指定ID的管理员定位限制状态
*
* @param id ID
* @returns {Promise}
*/
export function getAdminLocalVer(id: any) {
  return request({
    url: `${BASE_URL}/getAdminLocalVer/${id}`,
    method: 'get'
  })
}

/**
 * 修改管理员定位限制状态
 * @param data
 */
export function updateAdminLocalVer(data: any) {
  return request({
    url: `${BASE_URL}/updateAdminLocalVer`,
    method: 'put',
    data: data
  })
}